<div class="py-5 flex-1">
  <div class="table-header table-header-offset table-header-with-controls">
    <div class="table-header-controls flex-end">
      <div class="list-filters">
        <button type="button" appRemoveFocus class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
          <rkt-icon name="filter" class="table-header-filter-icon"></rkt-icon>
          Filter
          @if (activeFiltersCount$ | async) {
            <span class="table-header-filter-counter">{{ activeFiltersCount$ | async }}</span>
          }
        </button>
      </div>
    </div>
  </div>

  <div class="financial-account--journal-activity">
    <rkt-table
      [rows]="(journalActivity$ | async) || []"
      [columns]="columns"
      [limit]="10"
      (fetchData)="getJournalActivity($event)"
      [count]="(totalElements$ | async)!"
      [loadingIndicator]="(isLoading$ | async)!"
      [offset]="activePage"
      [rowHeight]="64"
      [isItemsAlignCenter]="true"
      [messages]="{ emptyMessage: 'No Journal Entries found.' }"
      emptyValuePlaceholder="--"
      dateTimeFormat="MM/dd/yy HH:mm"
      [sortParam]="sortParams"
      (rowActivated)="onActivityRowClick($event.financialAccountId)"
    ></rkt-table>
  </div>
</div>

<app-filter-menu
  #filterMenu
  [initialValues]="(activeFilters$ | async) || {}"
  [filters]="filters"
  (opened)="filterBtn.classList.add('opened')"
  (closed)="filterBtn.classList.remove('opened')"
  (saved)="applyFilters($event)"
/>
